module.exports = __webpack_public_path__ + "static/media/webpack-logo-cropped.4093efca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/webpack-logo-cropped.png
// module id = 61
// module chunks = 0